'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { currencyFormatter } from '@/utils/formatters/currency';

interface CartFooterProps {
  total: number;
}

export function CartFooter({ total }: CartFooterProps) {
  return (
    <footer
      className="shrink-0 border-t border-gray-200 bg-white p-3"
      data-testid={DataTestIdEnum.CART_FOOTER}
    >
      <div className="flex h-16 items-center justify-between gap-3 rounded-xxl bg-gray-50 px-4">
        <p
          className="whitespace-nowrap text-base text-gray-700"
          data-testid={DataTestIdEnum.CART_FOOTER_TOTAL}
        >
          Total
          {' '}
          <span className="font-bold text-gray-900">{currencyFormatter(total)}</span>
        </p>

        <Button
          disabled
          className="h-12 w-auto shrink-0 px-5 text-base"
          data-testid={DataTestIdEnum.CART_FOOTER_PROCEED_BUTTON}
        >
          Prosseguir
        </Button>
      </div>
    </footer>
  );
}
